import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=2bb65b2f&scoped=true&"
import script from "./DatePicker.vue?vue&type=script&lang=ts&"
export * from "./DatePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb65b2f",
  null
  
)

export default component.exports